/* Native disclosures work without JavaScript. Enhance deep links and refresh the
   existing scroll scene after height changes, including Shopify section reloads. */
(() => {
  if (window.PCSignalFAQ) { window.PCSignalFAQ.scan(); return; }
  const roots = new WeakSet();
  let refreshFrame;

  function refreshLayout() {
    cancelAnimationFrame(refreshFrame);
    refreshFrame = requestAnimationFrame(() => window.ScrollTrigger?.refresh());
  }

  function openAnchor(scope = document) {
    const id = location.hash.slice(1);
    if (!/^pcfq-(q|answer)-\d+$/.test(id)) return;
    const target = document.getElementById(id);
    if (!target || !scope.contains(target)) return;
    const disclosure = target.closest('.pcfq__disclosure');
    if (!disclosure) return;
    disclosure.open = true;
    requestAnimationFrame(() => {
      if (target.isConnected && location.hash.slice(1) === id) {
        target.scrollIntoView({ block: 'start', behavior: 'instant' });
      }
    });
  }

  function init(root) {
    if (roots.has(root)) return;
    roots.add(root);
    root.querySelectorAll('.pcfq__disclosure').forEach(details => {
      details.addEventListener('toggle', refreshLayout);
    });
    openAnchor(root);
    refreshLayout();
  }

  function scan(scope = document) {
    if (scope.matches?.('[data-pcfq]')) init(scope);
    scope.querySelectorAll('[data-pcfq]').forEach(init);
  }

  document.addEventListener('shopify:section:load', event => scan(event.target));
  window.addEventListener('hashchange', () => openAnchor());
  window.PCSignalFAQ = { scan };
  scan();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(), { once: true });
})();
